import {useMutation} from "@tanstack/react-query";
import axiosPublic from "../../api/axiosPublic";
import {useSnackbar} from "notistack";
import {useNavigate} from "react-router";

export default function usePublicQueries() {
    const {enqueueSnackbar} = useSnackbar()
    const navigate = useNavigate()

    // QUERIES ------------------------------------------------------

    // const registerSubscriptionQuery = useQuery({
    //     queryKey: ["register", "subscription"],
    //     queryFn: () =>
    //         axiosPrivate
    //             .get("subscription/")
    //             .then(r => r.data)
    // });
    //
    // const registerActivateQuery = useQuery({
    //     queryKey: ["register", "activate"],
    //     queryFn: ({queryKey}) => {
    //         const [, , params] = queryKey;
    //         return axiosPrivate
    //             .get("activate/", {params})
    //             .then(r => r.data);
    //     },
    //     enabled: false
    // });

    // MUTATIONS ------------------------------------------------------

    const loginMutation = useMutation({
        mutationFn: (data) =>
            axiosPublic
                .post("/api/token/", data)
                .then(r => r.data),
        onError: response => {
            if (response.status === 400) {
                enqueueSnackbar("Hibás email vagy jelszó.", {variant: 'error'});
            } else if (response.status === 401) {
                enqueueSnackbar("Hibás email vagy jelszó. Ellenőrizd a belépési adatokat.", {variant: 'error'});
            } else if (response.status === 500) {
                enqueueSnackbar("Szerver hiba. Próbáld újra később.", {variant: 'error'});
            } else {
                enqueueSnackbar("Ismeretlen hiba történt.", {variant: 'error'});
            }
        }
    });

    const registerMutation = useMutation({
        mutationFn: (data) =>
            axiosPublic
                .post("register_new/", data)
                .then(r => r.data),
        onSuccess: () => navigate('/success'),
    });

    const registerForBusinessMutation = useMutation({
        mutationFn: (data) =>
            axiosPublic
                .post("register_for_business/", data)
                .then(r => r.data),
        onSuccess: () => navigate('/login'),
    });

    const forgetPasswordMutation = useMutation({
        mutationFn: (data) =>
            axiosPublic
                .post("password/send_link/", data)
                .then(r => r.data),
        onSuccess: () => {
            navigate('/')
            enqueueSnackbar('Email kiküldve!', {variant: 'success'})
        },
    });
    const newPasswordMutation = useMutation({
        mutationFn: (data) =>
            axiosPublic
                .post("password/change_password/", data)
                .then(r => r.data),
        onSuccess: () => {
            navigate('/login')
            enqueueSnackbar('Sikeresen megváltoztatva!', {variant: 'success'})
        },
    });

    return {
        // Queries
        // registerSubscriptionQuery,
        // registerActivateQuery,

        // Mutations
        newPasswordMutation,
        registerForBusinessMutation,
        forgetPasswordMutation,
        registerMutation,
        loginMutation,
    };
}
